import * as React from "react";
import { Grid, Typography, Avatar, Box, Stack } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import { formatDate } from "utilities/date";
import ProgressScale from "components/ProgressScale";
import DummyTable from "components/DummyViews/DummyTable";
import { useSelector } from "react-redux";
import TenantPaymentsTable from "components/Tables/TenantPaymentsTable";
import { useGetTenantOccupancyActivePeriodsData } from "services/hooks/rentals";
import PlainCard from "components/PlainCard";
import { imageURL } from "services/API";


export default function TenantPayments(props) {
	const [details, setDetails] = React.useState("");
	const occupancy = useSelector((state) => state.occupancy)
    const { activePeriods, isLoadingActivePeriods } = useGetTenantOccupancyActivePeriodsData();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const openPopper = Boolean(anchorEl);
	const popperId = openPopper ? "simple-popover" : undefined;



	const handleClickPopOver = (event) => {
		setAnchorEl(event.currentTarget);
	};


	return (
		<Box m="20px">
			<Grid container spacing={2}>
				<Grid item xs={12}>
					{isLoadingActivePeriods && <ProgressScale />}
					<Box sx={{ mb: 3 }}>
						<Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
							<Avatar 
								src={occupancy?.related_tenant?.profile_picture ? `${imageURL}${occupancy.related_tenant.profile_picture}` : undefined}
								sx={{ 
									width: 64, 
									height: 64, 
									bgcolor: 'primary.main',
									fontSize: '1.5rem',
									fontWeight: 600
								}}
							>
								{!occupancy?.related_tenant?.profile_picture && 
									(occupancy?.related_tenant?.first_name?.charAt(0) || 'T').toUpperCase()
								}
							</Avatar>
							<Box sx={{ flex: 1 }}>
								<Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
									{occupancy?.related_tenant?.first_name} {occupancy?.related_tenant?.last_name}
								</Typography>
								<Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
									<Stack direction="row" spacing={0.5} alignItems="center">
										<PersonIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
										<Typography variant="body2" color="text.secondary">
											Tenant #{occupancy?.related_tenant?.tenant_number}
										</Typography>
									</Stack>
									{occupancy?.related_tenant?.phone_number && (
										<Stack direction="row" spacing={0.5} alignItems="center">
											<PhoneIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
											<Typography variant="body2" color="text.secondary">
												{occupancy.related_tenant.phone_number}
											</Typography>
										</Stack>
									)}
								</Stack>
							</Box>
						</Stack>
						<Typography variant="body1" color="text.secondary">
							Unit: <strong>{occupancy?.related_rental_unit?.unit_name}</strong> - {occupancy?.related_rental_unit?.related_rental?.rental_name}
						</Typography>
					</Box>
					
					<div>
						<Grid container>
							<Grid item xs={12} md={3}><PlainCard name="Days Left" value={activePeriods.days_left} /></Grid>
							<Grid item xs={12} md={3}><PlainCard name="Unit Rent" value={activePeriods.unit_rent} /></Grid>
							<Grid item xs={12} md={3}><PlainCard name="Current Outstanding Balance" value={activePeriods.total_outstanding_balance} /></Grid>
							<Grid item xs={12} md={3}><PlainCard name="Total Complete Months" value={activePeriods.completed_months} /></Grid>
						</Grid>
					</div>
					<Grid container spacing={2}>
						<Grid item xs={12} sx={{ marginTop: 3 }}>
							{isLoadingActivePeriods ? (
								<DummyTable />
							) : (
								<TenantPaymentsTable
									rows={activePeriods.schedules}
									handleClickPopOver={handleClickPopOver}
									id={popperId}
									formatDate={formatDate}
									setDetails={setDetails}
								/>
							)}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
}
